module.exports = __webpack_public_path__ + "img/intro-bg-mobile.10ab29eb.jpg";